module.exports = __webpack_public_path__ + "static/media/panda-logo.bde68f0c.png";